export default {
      id: "intuit-logo-usage",
      viewBox: "0 0 396 65",
      url: __webpack_public_path__ + "img/icons.svg#intuit-logo",
      toString: function () {
        return this.url;
      }
    }